import React, { useState } from "react";
import { Form, Alert } from "react-bootstrap";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { FaUserCircle, FaEnvelope, FaLock } from "react-icons/fa";

import AuthLayout from "../components/AuthLayout";
import { AuthField, PasswordField } from "../components/AuthFields";
import { useAuth } from "../context/AuthContext";

const POINTS = [
  "Programme & project delivery leadership",
  "Enterprise integration and cloud modernization",
  "Regulated-industry experience end to end",
];

function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // After login, go where the user was headed, otherwise their profile
  const from = location.state?.from?.pathname || "/account";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Login failed. Please check your credentials."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout
      icon={<FaUserCircle />}
      eyebrow="Sign in"
      title="Welcome Back"
      subtitle="Sign in to your account"
      brandTitle="Technology, transformation & digital excellence."
      brandLead="Sign in to manage your account and the team board."
      points={POINTS}
      footer={
        <>
          Don't have an account? <Link to="/signup">Sign up</Link>
        </>
      }
    >
      {/* aria-live so a failed sign-in is announced, not only shown */}
      <div aria-live="polite">
        {error && <Alert variant="danger">{error}</Alert>}
      </div>

      <Form onSubmit={handleSubmit}>
        <AuthField
          label="Email"
          icon={<FaEnvelope />}
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="admin@sarvavya.com"
          autoComplete="username"
          required
        />

        <PasswordField
          className="mb-4"
          label="Password"
          icon={<FaLock />}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter your password"
          autoComplete="current-password"
          required
        />

        <button type="submit" className="auth-submit" disabled={submitting}>
          {submitting ? "Signing in…" : "Sign In"}
        </button>
      </Form>
    </AuthLayout>
  );
}

export default AdminLogin;
